'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var SmallTitle = require('../SmallTitle/SmallTitle.js');
var CommonLink = require('../CommonLink/CommonLink.js');
var styledComponents = require('./styled-components.js');

var TitleAndLink = function (props) {
    var titleText = props.titleText, linkText = props.linkText, url = props.url, direction = props.direction, dataTestId = props["data-testid"];
    return (React__default.createElement(styledComponents.MainContainer, { "data-testid": dataTestId, direction: direction },
        React__default.createElement(SmallTitle, { text: titleText, inline: true }),
        " ",
        linkText && React__default.createElement(CommonLink, { text: linkText, url: url })));
};
TitleAndLink.defaultProps = {
    direction: 'row',
};

module.exports = TitleAndLink;
